/* eslint-disable import/no-named-as-default-member */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/order */
/* eslint-disable camelcase */
import { paramCase, sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
import {
  Card,
  List,
  Button,
  Container,
  Typography,
  Box,
  IconButton,
  Stack,
  Paper,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  TextField,
} from '@mui/material';
// routes
import axios, { getErrorMessage } from 'utils/axios';
import useIsMountedRef from 'hooks/useIsMountedRef';
import CRUD from 'utils/Crud';
import { fDate, fDateTime } from 'utils/formatTime';
import { PATH_DASHBOARD } from '../../routes/paths';
// hooks
import useSettings from '../../hooks/useSettings';
import { useSnackbar } from 'notistack';
// components
import Page from '../../components/Page';
import Iconify from '../../components/Iconify';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import Swal from 'sweetalert2';
import AppColors from 'utils/AppColors';
import Label from 'components/Label'; // Ensure this is correct import path for Label component
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import CreateCampaignDialog from 'sections/@dashboard/ CreateCampaignDialog';

import { Link as RouterLink } from 'react-router-dom';

export default function PushNotification() {
  const { themeStretch } = useSettings();
  const isMountedRef = useIsMountedRef();
  const { enqueueSnackbar } = useSnackbar();

  const [sort, setSort] = useState({
    field: 'id',
    order: 'desc',
    page_size: 10, // default page size
    page: 1,       // current page starts at 1 (instead of 0)
    start_date: null,
    end_date: null,
  });

  const [data, setData] = useState({
    data: [],
    current_page: 1,
    total_pages: 0,
    total_size: 0,
    page_size: 10,
  });

  const [state, setState] = useState({
    loading: false,
    loadComplete: false,
    error: null,
    isDeleting: false,
  });

  const [dialog, setDialog] = useState({ open: false });
  const [dialog2, setDialog2] = useState({ open: false, item: null });
  const [search, setSearch] = useState({ open: false, query: '', list: [] });

  // Fetch campaigns data
  useEffect(() => {
    getInitData(sort.page);
  }, [sort.page, sort.page_size, sort.order, sort.start_date, sort.end_date]);

  async function getInitData(page = 1) {
    setState((prev) => ({ ...prev, loading: true, loadComplete: false, error: null }));

    const sdate = sort.start_date ? new Date(sort.start_date).toISOString() : '';
    const edate = sort.end_date ? new Date(sort.end_date).toISOString() : '';

    try {
      let str = `?sort_order=${sort.order}&page=${page}&page_size=${sort.page_size}`;
      str += `&start_date=${sdate}&end_date=${edate}`;

      const response = await axios.get(CRUD.campaign.root + str);

      if (isMountedRef.current) {
        // Update data and current page from response
        setData({
          data: response.data.data,
          current_page: response.data.current_page,
          total_pages: response.data.total_pages,
          total_size: response.data.total_size,
          page_size: response.data.page_size,
        });

        // Sync internal page state with data response page
        setSort((prevSort) => ({ ...prevSort, page: response.data.current_page }));

        setState((prev) => ({ ...prev, loading: false, loadComplete: true, error: null }));
      }
    } catch (error) {
      setState((prev) => ({
        ...prev,
        loading: false,
        loadComplete: false,
        error: getErrorMessage(error),
      }));
    }
  }

  // Pagination controls
  const goToPage = (requestedPage) => {
    if (requestedPage >= 1 && requestedPage <= data.total_pages && requestedPage !== sort.page) {
      setSort((prev) => ({ ...prev, page: requestedPage }));
    }
  };

  // Page size change handler
  const onPageSizeChange = (newSize) => {
    setSort((prev) => ({ ...prev, page_size: newSize, page: 1 })); // Reset to page 1 on page size change
  };

  // Remove campaign with confirmation
  async function removeCampaignItem(item) {
    Swal.fire({
      text: 'Do you want to remove this campaign?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: AppColors.DANGER,
      confirmButtonText: 'Yes, continue',
      reverseButtons: true,
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
      preConfirm: async () => {
        setState((s) => ({ ...s, isDeleting: true }));
        try {
          await axios.delete(`${CRUD.campaign.root}/${item.campaign_id}`);
          const filtered = data.data.filter((e) => e.campaign_id !== item.campaign_id);
          setData({ ...data, data: filtered });
          setState((s) => ({ ...s, isDeleting: false }));
          enqueueSnackbar('Campaign deleted successfully', { variant: 'success' });
          return true;
        } catch (error) {
          setState((s) => ({ ...s, isDeleting: false }));
          Swal.showValidationMessage(`${getErrorMessage(error) || error.toString()}`);
          return false;
        }
      },
    }).then((result) => {
      if (result.value) {
        Swal.close();
      }
    });
  }

  // Helper to format date or show '-' fallback
  const formatDate = (dateString) => (dateString ? fDateTime(dateString) : '-');
  const formatDateShort = (dateString) => (dateString ? fDate(dateString) : '-');

  function getStatusColor(status) {
    switch (status) {
      case 'pending':
        return 'warning';
      case 'completed':
        return 'success';
      case 'sending':
      case 'processing':
      case 'waiting':
        return 'info';
      case 'paused':
        return 'default';
      case 'failed':
        return 'error';
      default:
        return 'default';
    }
  }

  const renderCampaignItem = (item) => {
    const deleted = Boolean(item.deleted_at);

    const deletedStyles = {
      textDecoration: 'line-through',
      color: 'error.main',
      opacity: 0.7,
    };

    return (
      <Paper
        key={item.campaign_id}
        elevation={2}
        sx={{
          mb: 2,
          p: 2,
          bgcolor: deleted ? 'error.lighter' : 'background.paper',
          borderLeft: `6px solid ${deleted ? 'error.main' : 'primary.main'}`,
        }}
      >
        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" spacing={2}>
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="subtitle1"
              sx={deleted ? deletedStyles : { fontWeight: 'bold', cursor: 'pointer' }}
              noWrap
              title={item.topic}
              color={"primary"}
              component={RouterLink}
              to={`${PATH_DASHBOARD.pushNotification.root}/campaign/${item.campaign_id}/details`}
              // onClick={()=> setDialog2({open:true, item})}
            >
              {item.topic}
            </Typography>

            <Typography
              variant="body2"
              sx={{ mt: 0.5, whiteSpace: 'normal', ...(deleted ? deletedStyles : {}) }}
              title={item.message}
            >
              {item.message.length > 100 ? `${item.message.substring(0, 100)}…` : item.message}
            </Typography>

            <Stack direction="row" spacing={1} sx={{ mt: 1, flexWrap: 'wrap' }}>
              <Typography variant="caption" sx={deleted ? deletedStyles : {}}>
                <strong>Category:</strong> {sentenceCase(item.category)}
              </Typography>
              <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
              <Typography variant="caption" sx={deleted ? deletedStyles : {}}>
                <strong>Affected Users:</strong> {item.affected_users.toLocaleString()}
              </Typography>
              <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
              <Typography variant="caption" sx={deleted ? deletedStyles : {}}>
                <strong>Scheduled At:</strong> {formatDate(item.scheduled_at)}
              </Typography>

              {item.is_approved === '1' || item.is_approved === true ? (
                <>
                  <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                  <Typography variant="caption" sx={deleted ? deletedStyles : { color: 'success.main' }}>
                    <strong>Approved</strong> {formatDateShort(item.approved_at)}
                  </Typography>
                </>
              ) : (
                <>
                  <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                  <Typography
                    variant="caption"
                    sx={{
                      color: 'warning.main',
                      fontWeight: 'bold',
                      ...(deleted ? deletedStyles : {}),
                    }}
                  >
                    Waiting for Approval
                  </Typography>
                </>
              )}
              <Typography variant="caption" sx={deleted ? deletedStyles : {}}>
                <strong>Created by:</strong> {item.staff_name}
              </Typography>
              <Typography variant="caption" sx={deleted ? deletedStyles : {}}>
                <strong>Approved By:</strong> {item.approved_by || ''}
              </Typography>
            </Stack>
          </Box>

          <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', pl: 2 }}>
            <Stack spacing={1} alignItems="flex-end">
              <Label color={getStatusColor(item.status)}>
                {sentenceCase(item.status)}
              </Label>

              <Typography
                variant="caption"
                sx={{ maxWidth: 200, textAlign: 'right', whiteSpace: 'normal', ...(deleted ? deletedStyles : {}) }}
              >
                {item.status_msg || '-'}
              </Typography>
              {!deleted && 
              <IconButton
                aria-label="delete"
                color="error"
                onClick={() => removeCampaignItem(item)}
                disabled={state.isDeleting}
                size="small"
                sx={{ mt: 1 }}
              >
                <Iconify icon="eva:trash-2-outline" width={20} height={20} />
              </IconButton>}
            </Stack>
          </Box>
        </Stack>
      </Paper>
    );
  };

  return (
    <Page title="Push Notification">
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading="Push Notification"
          links={[
            { name: 'Notification campaigns', href: PATH_DASHBOARD.pushNotification.root },
            { name: 'Campaigns' },
          ]}
          action={
            <>
              <Button
                variant="contained"
                color="primary"
                onClick={() => setDialog({ open: true })}
                startIcon={<Iconify icon="mdi:download-box" width={20} height={20} />}
                sx={{ mr: 2 }}
              >
                Schedule Notification
              </Button>
            </>
          }
        />

        {/* Filter UI */}
        <Card sx={{ p: 2, my: 2 }}>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={2}
            alignItems="center"
            justifyContent="flex-start"
            flexWrap="wrap"
          >
            <FormControl sx={{ minWidth: 150 }}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="From date"
                  value={sort.start_date}
                  onChange={(newValue) => setSort((s) => ({ ...s, start_date: newValue, page: 1 }))}
                  renderInput={(params) => <TextField {...params} size="small" />}
                />
              </LocalizationProvider>
            </FormControl>

            <FormControl sx={{ minWidth: 150 }}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="To date"
                  value={sort.end_date}
                  onChange={(newValue) => setSort((s) => ({ ...s, end_date: newValue, page: 1 }))}
                  renderInput={(params) => <TextField {...params} size="small" />}
                />
              </LocalizationProvider>
            </FormControl>

            <FormControl sx={{ minWidth: 180 }}>
              <InputLabel id="sort-order-label">Sort Order</InputLabel>
              <Select
                labelId="sort-order-label"
                value={sort.order}
                label="Sort Order"
                onChange={(e) => setSort((s) => ({ ...s, order: e.target.value, page: 1 }))}
                size="small"
              >
                <MenuItem value="asc">Ascending</MenuItem>
                <MenuItem value="desc">Descending</MenuItem>
              </Select>
            </FormControl>

            <Button
              variant="outlined"
              onClick={() => getInitData(1)}
              sx={{ whiteSpace: 'nowrap' }}
              disabled={state.loading}
            >
              Apply changes
            </Button>
          </Stack>
        </Card>

        {!state.loading && state.error && (
          <Card>
            <Box padding={10} display="flex" justifyContent="center">
              <Typography color="error">Error: {state.error}</Typography>
            </Box>
          </Card>
        )}

        <Card sx={{ p: 2, mt: 2, minHeight: 600, position: 'relative', overflowY: 'auto' }}>
          {/* Loading overlay */}
          {state.loading && (
            <Box
              sx={{
                width: '100%',
                height: '100%',
                position: 'absolute',
                top: 0,
                left: 0,
                zIndex: 10,
                bgcolor: 'background.paper',
                opacity: 0.8,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <CircularProgress size={64} />
            </Box>
          )}

          <Box sx={{ opacity: state.loading ? 0.6 : 1 }}>
            {search.open && (
              <Box
                sx={{
                  display: 'flex',
                  alignContent: 'center',
                  justifyContent: 'space-between',
                  width: '100%',
                  padding: 2,
                }}
              >
                <Typography variant="subtitle1" color="primary">
                  Showing results for: {search.query}
                </Typography>
                <Button
                  variant="outlined"
                  color="error"
                  startIcon={<Iconify icon="carbon:close-filled" />}
                  onClick={() => setSearch((s) => ({ ...s, open: false }))}
                  disabled={state.loading}
                >
                  Close Search
                </Button>
              </Box>
            )}

            {!search.open && data.data.length === 0 && !state.loading && (
              <Typography variant="body1" align="center" sx={{ mt: 3 }}>
                No campaigns found.
              </Typography>
            )}

            <List disablePadding>
              {(search.open ? search.list : data.data).map((item) => renderCampaignItem(item))}
            </List>
          </Box>

          {/* Pagination controls */}
          {!search.open && data.total_pages > 1 && (
            <Stack
              direction="row"
              spacing={1}
              justifyContent="center"
              alignItems="center"
              sx={{ mt: 2 }}
            >
              <Button
                variant="outlined"
                disabled={sort.page <= 1 || state.loading}
                onClick={() => goToPage(sort.page - 1)}
              >
                Previous
              </Button>
              <Typography variant="body2" sx={{ minWidth: 60, textAlign: 'center' }}>
                Page {sort.page} of {data.total_pages}
              </Typography>
              <Button
                variant="outlined"
                disabled={sort.page >= data.total_pages || state.loading}
                onClick={() => goToPage(sort.page + 1)}
              >
                Next
              </Button>

              {/* Page size selector */}
              <FormControl size="small" sx={{ minWidth: 100, ml: 2 }}>
                <InputLabel id="page-size-label">Page Size</InputLabel>
                <Select
                  labelId="page-size-label"
                  value={sort.page_size}
                  label="Page Size"
                  onChange={(e) => onPageSizeChange(e.target.value)}
                >
                  {[10, 25, 50, 100].map((size) => (
                    <MenuItem key={size} value={size}>
                      {size}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Stack>
          )}
        </Card>

        {dialog.open && (
          <CreateCampaignDialog
            open={dialog.open}
            handleClose={() => setDialog({ open: false })}
            handleComplete={() => {
              setDialog({ open: false });
              getInitData();
            }}
          />
        )}

        {dialog2.open && (
          <CreateCampaignDialog
            open={dialog2.open}
            item={dialog2.item}
            handleClose={() => setDialog2({ open: false, item:null })}
          />
        )}
      </Container>
    </Page>
  );
}
